/* eslint-disable no-undef */
import api from '@/api/index'

export const UPDATE_MENU_DISHES = 'UPDATE_MENU_DISHES'
export const CHANGE_DISH_COUNT = 'CHANGE_DISH_COUNT'
export const CLEAR_ORDERED_DISH_BY_PERIOD_ID = 'CLEAR_ORDERED_DISH_BY_PERIOD_ID'
export const COMMIT_ORDER = 'COMMIT_ORDER'
export const ADDRESS_LIST = 'ADDRESS_LIST'

export default {
  state: {
    diningHallList: [],
    foodList: [],
    userAddressList: [],
    activityInfo: {
      boardFee: 0,
      fullGive: null,
      fullSubtraction: null,
      position: null,
      isRandomSubtractionActivity: 0,
      diningType: []
    }
  },
  mutations: {
    [UPDATE_MENU_DISHES] (state, data) {
      Object.assign(state, data)
    }
  },
  actions: {
    // 更新菜单
    [UPDATE_MENU_DISHES] ({
      state,
      commit
    }, params) {
      return new Promise(function (resolve, reject) {
        api.findPeriodPlanFoodListByPeriodNameIdAndQueryTime(params).then(data => {
          commit(UPDATE_MENU_DISHES, {
            diningHallList: data.data.diningHallList
          })
          resolve(data.data)
        }, err => {
          reject(err)
        })
      })
    },
    // 更新地址
    [ADDRESS_LIST] ({
      state,
      commit
    }, params) {
      return new Promise(function (resolve, reject) {
        api.queryUserAddressPageList(params).then(data => {
          console.log(data)
          commit(UPDATE_MENU_DISHES, {
            userAddressList: data.data.userAddressList
          })
          resolve(data.data)
        }, err => {
          reject(err)
        })
      })
    },
    // param: optr: 'd'(减操作) 'a'(加操作)
    //        food, amount,currentHallIndex,categoryIndex,goodIndex
    [CHANGE_DISH_COUNT] ({
      commit,
      state
    }, param) {
      return new Promise(function (resolve, reject) {
        let diningHallList = state.diningHallList
        let currentHallIndex = param.currentHallIndex
        let categoryIndex = param.categoryIndex
        let goodIndex = param.goodIndex
        diningHallList[currentHallIndex].foodCategoryList[categoryIndex].foodList[goodIndex].amount = param.amount
        commit(UPDATE_MENU_DISHES, {
          diningHallList
        })
        resolve()
      })
    },
    [CLEAR_ORDERED_DISH_BY_PERIOD_ID] ({
      commit,
      state
    }, hallId) {
      let diningHallList = state.diningHallList
      diningHallList.forEach(diningHall => {
        if (diningHall.diningHallId === hallId) {
          diningHall.foodCategoryList.forEach((foodCategory) => {
            foodCategory.foodList.forEach(food => {
              food.amount = 0
            })
          })
        }
      })
      commit(UPDATE_MENU_DISHES, {
        diningHallList
      })
    },
    // 确认订单的方法 reject 会返回错误提示
    [COMMIT_ORDER] ({
      commit,
      state
    }, data) {
      return new Promise(function (resolve, reject) {
        api.queryShoppingCartPayOrderJoinActivityList(null, data).then(res => {
          commit(UPDATE_MENU_DISHES, {
            foodList: data.foodList,
            activityInfo: res.data
          })
          resolve(res.data)
        }, err => {
          reject(err)
        })
      })
    },
    getSelectedDish ({
      commit,
      state
    }, periodPlanId) {
      return new Promise(function (resolve, reject) {
        let selectedDish = []
        if (state.allDishes[periodPlanId]['cates'] === undefined || !Array.isArray(state.allDishes[periodPlanId]['cates'])) return []
        state.allDishes[periodPlanId]['cates'].forEach(cate => {
          cate.items.forEach(dish => {
            if (dish.count > 0) {
              selectedDish.push(dish)
            }
          })
        })
        resolve(JSON.parse(JSON.stringify(selectedDish)))
      }, (data) => {
        reject(data)
      })
    }
  }
}

// 生成 tag 和 包含该 tag 的菜品对应的 map, 结构为 {tag1:[dish1,dish2...], tag2:[dish2,dish3...]}
function makeTagDishMap (allDishes, limitType, checkType) {
  if (!Array.isArray(allDishes) || allDishes.length === 0) {
    return new Map()
  }
  let map = new Map()
  let set = new Set()
  allDishes.forEach(cate => {
    cate.items.forEach(dish => {
      dish.tags.forEach(tag => {
        if (tag.limitType === limitType && tag.checkType === checkType) {
          let exist = false
          for (let item of set.values()) {
            if (item.tagId === tag.tagId) {
              exist = true
            }
          }
          if (exist === false) {
            set.add(tag)
          }
        }
      })
    })
  })
  for (let item of set.values()) {
    let dishArr = []
    allDishes.forEach(cate => {
      cate.items.forEach(dish => {
        dish.tags.forEach(tag => {
          if (tag.tagId === item.tagId) {
            dishArr.push(dish)
          }
        })
      })
    })
    map.set(item, dishArr)
  }
  return map
}
// 检查范围限制
// param: optr: 'd'(减操作) 'a'(加操作)
//        periodPlanId
function checkScopeLimit (param, allDishes, origDish) {
  let map = makeTagDishMap(allDishes, 1, 2)
  let tips = ''
  if (param.optr === 'a') {
    let canBeAddCount = true
    origDish.tags.forEach(dishTag => {
      for (let [tag, dishes] of map.entries()) {
        if (dishTag.tagId === tag.tagId) {
          let totalCount = dishes.reduce((acc, cur) => {
            return acc + cur.count
          }, 0)
          if (totalCount > tag.userLimitAmount - 1) {
            canBeAddCount = false
            tips = `"${tag.tagName}"类菜品数量不可超过${tag.userLimitAmount}份`
          } else if (totalCount === tag.userLimitAmount - 1) {
            dishes.forEach(dish => {
              dish.addDisabled = true
            })
          }
        }
      }
    })
    if (canBeAddCount) {
      origDish.count++
    }
  } else if (param.optr === 'd') {
    origDish.tags.forEach(dishTag => {
      for (let [tag, dishes] of map.entries()) {
        if (dishTag.tagId === tag.tagId) {
          dishes.forEach(dish => {
            dish.addDisabled = false
          })
        }
      }
    })
  }
  return tips
}

function getSelectedDish (state, periodPlanId) {
  let selectedDish = []
  if (state.allDishes[periodPlanId] === undefined || !Array.isArray(state.allDishes[periodPlanId])) return []
  state.allDishes[periodPlanId].forEach(cate => {
    cate.items.forEach(dish => {
      if (dish.count > 0) {
        selectedDish.push(dish)
      }
    })
  })
  return JSON.parse(JSON.stringify(selectedDish))
}



// WEBPACK FOOTER //
// ./src/store/modules/ordermeal.js